import { render, staticRenderFns } from "./e-chip-type.vue?vue&type=template&id=178a74da&scoped=true&lang=pug&"
import script from "./e-chip-type.vue?vue&type=script&lang=js&"
export * from "./e-chip-type.vue?vue&type=script&lang=js&"
import style0 from "./e-chip-type.vue?vue&type=style&index=0&id=178a74da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178a74da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
